import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import { AppAbilityType } from "interfaces/ClientInterface/IAbility";

export const AbilityContext = createContext<AppAbilityType>(null as unknown as AppAbilityType);
export const Can = createContextualCan(AbilityContext.Consumer);
